/**
 * 策划中心-任务指派-左侧导航
 * 2019-05-08
 * Qian.qianchen
 */
"use strict";
angular.module("taskAssignmentLeftModule", []).
directive("taskAssignmentLeft", ["$state", "$timeout", "taskAssignmentService", "$q", function($state, $timeout, taskAssignmentService, $q) {
    return {
        restrict: "E",
        replace: true,
        templateUrl: "./planningCenter/taskAssignment/left/left_tpl.html",
        scope: {
            selected: "="
        },
        link: function(scope, $elem, $attrs) {
            initStatus();
            /**
             * [initStatus description] 初始化状态
             * @return {[type]} [description]
             */
            function initStatus() {
                scope.status = {
                    expanded: false,
                    expandedLeve2: ""
                };
                getAssignmentRights().then(function() {
                    autoLocation();
                });
            }
            /**
             * [autoLocation description] 自动定位
             * @return {[type]} [description]
             */
            function autoLocation() {
                scope.$watch("selected", (newV, oldV) => {
                    if (newV === "taskassignment") {
                        scope.status.expanded = true;
                        let routerName = $state.current.name;
                        let routerArray = routerName.split(".");
                        if ($state.current.name != "front.plan.taskassignment") {
                            scope.status.expandedLeve2 = routerArray[3];
                            scope.status.selectedLeve3 = routerArray[3] + "." + routerArray[4];
                        }
                    } else {
                        scope.status.expandedLeve2 = "";
                    }
                });
            }
            /**
             * [getAssignmentRights description] 获取权限
             * @return {[type]} [description]
             */
            function getAssignmentRights() {
                let defer = $q.defer();
                taskAssignmentService.getRights().then(function(result) {
                    scope.status.rights = result;
                    defer.resolve();
                });
                return defer.promise
            }
            /**
             * [expandLeve2 description] 展开二级
             * @param  {[type]} type [description] 类型名称
             * @return {[type]}      [description]
             */
            scope.expandLeve2 = function(type, $event) {
                scope.status.expandedLeve2 = type;
                $timeout(() => {
                    $($event.currentTarget).next("ul").find("a")[0].click();
                    scope.$root.narrowNavigation = false;
                });
            };
            /**
             * [selectLeve3 description] 选中三级
             * @param  {[type]} routerNamePart [description] 路由名称
             * @return {[type]}            [description]
             */
            scope.selectLeve3 = function(routerNamePart) {
                let routerName = "front.plan.taskassignment." + routerNamePart;
                $state.go(routerName, {}, { reload: routerName });
                scope.status.selectedLeve3 = routerNamePart;
                if (scope.selected !== "taskassignment") {
                    $timeout(() => {
                        scope.selected = "taskassignment";
                    }, 500);
                }
            };
        }
    };
}]);